import { ApolloClient, InMemoryCache, ApolloProvider, HttpLink, createHttpLink, ApolloLink } from '@apollo/client';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ENDPOINT } from './Constants';
import './index.css';
import App, { userAgentApplicationState } from './pages/App';
import * as serviceWorker from './serviceWorker';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';

const httpLink = createHttpLink({
  uri: ENDPOINT,
});

const handleUnauthorized = () => {
  localStorage.removeItem('accessToken');
  if (userAgentApplicationState) {
    // Read account BEFORE logout() clears the MSAL cache
    const account = userAgentApplicationState.getAccount();
    const loginHint = account?.userName || '';
    userAgentApplicationState.logout();
    const logoutUrl = new URL('https://login.microsoftonline.com/common/oauth2/v2.0/logout');
    logoutUrl.searchParams.set('post_logout_redirect_uri', window.location.origin);
    if (loginHint) {
      logoutUrl.searchParams.set('login_hint', loginHint);
    }
    window.location.href = logoutUrl.toString();
  } else {
    window.location.replace(window.location.origin);
  }
};

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors?.some(e => e.extensions?.code === 'UNAUTHENTICATED')) {
    handleUnauthorized();
  }

  if (networkError?.statusCode === 401) {
    handleUnauthorized();
  }
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('accessToken');
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});

const link = ApolloLink.from([errorLink, authLink.concat(httpLink)]);

const client = new ApolloClient({
  link,
  cache: new InMemoryCache(),
});

// Add the format command for adding parameters to strings. For Example:
//    'This is a test: {testName}'.format({testName: 'Test Hello World'})
if (!String.prototype.format) {
  // eslint-disable-next-line
  String.prototype.format = function (values) {
    return this.replace(/{(\w+)}/g, function (match, key) {
      return typeof values[key] !== 'undefined' ? values[key] : match;
    });
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ApolloProvider client={client}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ApolloProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
